import { defineStore } from 'pinia';
import {getUserDashboard, getUserInfoService, updateProfile} from "@/services/userService";

export const useUserStore = defineStore('user', {
    state: () => ({
        user: null, // Stores user information
        loading: false, // Tracks the loading state
        error: null, // Stores error messages
    }),
    actions: {
        /**
         * Fetch user information and update the store state
         */
        async info() {
            this.loading = true;
            this.error = null;

            try {
                const userInfo = await getUserInfoService();
                this.user = userInfo;
                return userInfo;
            } catch (error) {
                console.error('Error fetching user information:', error);
                this.error = 'Failed to fetch user information';
                throw error;
            } finally {
                this.loading = false;
            }
        },

        /**
         * Update user profile and update the store state
         * @param {Object} user - The user data to update
         */
        async update(user) {
            this.loading = true;
            this.error = null;

            try {
                const updatedUser = await updateProfile(user);
                this.user = updatedUser; // Update local state with the new user data
                return updatedUser;
            } catch (error) {
                console.error('Error updating user information:', error);
                this.error = 'Failed to update user information';
                throw error;
            } finally {
                this.loading = false;
            }
        },

        /**
         * Get dashboard information for the user
         * @returns {Promise<Object>} Dashboard information
         */
        async dashboard() {
            this.loading = true;
            this.error = null;

            try {
                const dashboardInfo = await getUserDashboard();
                return dashboardInfo;
            } catch (error) {
                console.error('Error fetching user dashboard:', error);
                this.error = 'Failed to fetch user dashboard';
                throw error;
            } finally {
                this.loading = false;
            }
        },
    },
    getters: {
        /**
         * Check if user is logged in
         */
        isLoggedIn: (state) => !!state.user,
    },
});
